import environment from 'environment';

let configuration = {
  environment: 'development',
  appBaseUrl: `http://localhost:3000`,
  apiBaseUrl: `http://localhost:8000/api`,
  vexBaseUrl: `https://test-login.vex.com`,
  vrBaseUrl: `http://test-vr.vex.com`,
  vrSwitchBaseUrl: `https://vrswitch.vex.com`,
  clientId: 19,
  google: {
    clientId: '711283995321-r2g7qu7c781uj4p73c78d6jc3j1tpdck.apps.googleusercontent.com',
    redirectUrl: 'http://localhost:3000/google/auth/redirect',
    scopes: 'https://www.googleapis.com/auth/drive.file',
    authBase: 'https://accounts.google.com/o/oauth2/v2/auth',
    drivePath: 'VEXcode VR DEV'
  },
  dropbox: {
    clientId: 'j7rrpyg9x2zm7j8',
    redirectUrl: 'http://localhost:3000/dropbox/auth/redirect',
    authBase: 'https://www.dropbox.com/oauth2/authorize',
    basePath: 'Dropbox/Apps/VEXcode VR DEV'
  }
}

if (environment.environment === 'stage') {
  configuration = {
    environment: 'stage',
    appBaseUrl: `https://test-vradmin.vex.com`,
    apiBaseUrl: `https://test-vradminapi.vex.com/api`,
    vexBaseUrl: `https://test-login.vex.com`,
    vrBaseUrl: `https://test-vr.vex.com`,
    vrSwitchBaseUrl: `https://vrswitch.vex.com`,
    clientId: 51,
    google: {
      clientId: '711283995321-a8c8avdlvjhmrqh5q73jl4g5dfi56dap.apps.googleusercontent.com',
      redirectUrl: 'https://test-vradmin.vex.com/google/auth/redirect',
      scopes: 'https://www.googleapis.com/auth/drive.file',
      authBase: 'https://accounts.google.com/o/oauth2/v2/auth',
      drivePath: 'VEXcode VR TEST'
    },
    dropbox: {
      clientId: 'hotat3y8mhe1qj3',
      redirectUrl: 'https://test-vradmin.vex.com/dropbox/auth/redirect',
      authBase: 'https://www.dropbox.com/oauth2/authorize',
      basePath: 'Dropbox/Apps/VEXcode VR TEST'
    }
  }
}

if (environment.environment === 'production') {
  configuration = {
    environment: 'production',
    appBaseUrl: `https://vradmin.vex.com`,
    apiBaseUrl: `https://vradminapi.vex.com/api`,
    vexBaseUrl: `https://login.vex.com`,
    vrBaseUrl: `https://vr.vex.com`,
    vrSwitchBaseUrl: `https://vrswitch.vex.com`,
    clientId: 60,
    google: {
      clientId: '841766753215-esttp4km65ico9b3pqu0m4umj35semau.apps.googleusercontent.com',
      redirectUrl: 'https://vradmin.vex.com/google/auth/redirect',
      scopes: 'https://www.googleapis.com/auth/drive.file',
      authBase: 'https://accounts.google.com/o/oauth2/v2/auth',
      drivePath: 'VEXcode VR'
    },
    dropbox: {
      clientId: 'f14shimmmxl1xxh',
      redirectUrl: 'https://vradmin.vex.com/dropbox/auth/redirect',
      authBase: 'https://www.dropbox.com/oauth2/authorize',
      basePath: 'Dropbox/Apps/VEXcode VR'
    }
  }
}

export default configuration